import * as React from "react";

/**
 * Layout for the Settings page to constrain the width of the content.
 */
export function SettingsPageLayout(props: React.PropsWithChildren) {
  return <div style={{ maxWidth: "1200px" }}>{props.children}</div>;
}
